import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AuthGuard, CmsConfig, I18nModule, provideDefaultConfig } from "@spartacus/core";
import { PageLayoutModule, OutletModule, OutletRefModule, PageSlotModule, MediaModule, GenericLinkModule, IconModule } from "@spartacus/storefront";
import { KbNavigationUiComponent } from "./kb-navigation-ui.component";
import { RouterModule } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SecureGuard } from "src/app/services/Guards/secure.service";



@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    IconModule,
    GenericLinkModule,
    I18nModule,
  ],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        NavigationUIComponent: {
          component: KbNavigationUiComponent,
        },
      },
    }),
  ],
  exports: [KbNavigationUiComponent],
  declarations: [KbNavigationUiComponent]
})
export class KbNavigationUiModule {

}
